<template>
  <div ref="actionAddQuestion">
    <sFormItem
      :label="$t('Automation.Text')"
      prop="Message"
      :rules="rules.Message">
      <div class="flex">
        <sInput
          ref="text"
          clearable
          :disabled="disabled"
          max-length="7"
          :placeholder="$t('Automation.MailMessage')"
          rows="3"
          type="textarea"
          :value="valueMutable.Message"
          @update:value="sendValue('Message', $event)"/>
        <div
          class="ml-2">
          <AutomationTags
            v-if="!disabled"
            @addedTag="addedTag('Message', $event)"/>
        </div>
      </div>
    </sFormItem>
  </div>
</template>
<script>
import AutomationTags from 'components/automation/AutomationTags.vue'

import automations from 'mixins/automations'

/**
 * Автоматизация. Действие Надіслати приватне повідомлення учаснику
 */
export default {
  name: 'sendQuestion',
  mixins: [ automations ],
  data() {
    const that = this
    return {
      rules: {
        Message: {
          required: true,
          trigger: 'change',
          validator(rule, value, callback) {
            if (!that.valueMutable?.Message?.trim()) {
              callback(new Error(that.$t('Validate.Required')))
            }
            const errorTags = that.$_checkCorrectTagsOnString(that.valueMutable?.Message)
            if (errorTags?.length) {
              callback(new Error(`${that.$t('Automation.VariablesNotExists')}: ${errorTags.join(', ')}`))
            }
            callback()
          },
        },
      },
    }
  },
  methods: {
    addedTag(field, tag) {
      this.sendValue(field, `${this.valueMutable[field] || ''} {${tag}}`)
    },
    sendValue(field, props) {
      const result = this.$_.cloneDeep(this.value)
      const parameters = this.$_.cloneDeep(this.valueMutable)

      parameters[field] = props
      result.parameters = JSON.stringify(parameters)

      this.$emit('update:value', result)
    }
  },
  computed: {
    valueMutable: {
      get() {
        const defaultMode = {
          Message: '',
        }
        if (!this.value?.parameters) {
          return defaultMode
        }
        try {
          return JSON.parse(this.value.parameters) || {}
        } catch {
          this.$notice.error({
            title: this.$t('Common.ErrorTitle'),
            message: this.$t('Automation.ErrorActionParameters'),
            showClose: true,
            progress: true,
          })
          return defaultMode
        }
      },
    },
  },
  created() {
  },
  props: {
    value: {
      type: Object
    },
    disabled: {
      type: Boolean
    },
    additionalProps: {
      type: [Object, Array]
    },
  },
  components: {
    AutomationTags,
  }
}
</script>
